import { getMonth, getYear } from 'date-fns';
import { isNotNil } from 'ramda';

export const getAge = (
  date: Date | undefined,
  birthdate: Date | undefined
): number | undefined =>
  isNotNil(date) && isNotNil(birthdate)
    ? getYear(date) -
      getYear(birthdate) +
      (getMonth(date) + 1 - (getMonth(birthdate) + 1)) / 12
    : undefined;
